/**
 * FursPremises API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  closeFursBusinessPremise,
  getFursBusinessPremise,
  listFursBusinessPremises,
  registerFursMovablePremise,
  registerFursRealEstatePremise,
} from "../generated/furs-premises/furs-premises";

import { wrapMethod } from "./utils";

export const fursPremises = {
  /** @see listFursBusinessPremises */
  listFursBusinessPremises: wrapMethod(listFursBusinessPremises),

  /** @see getFursBusinessPremise */
  getFursBusinessPremise: wrapMethod(getFursBusinessPremise),

  /** @see registerFursRealEstatePremise */
  registerFursRealEstatePremise: wrapMethod(registerFursRealEstatePremise),

  /** @see registerFursMovablePremise */
  registerFursMovablePremise: wrapMethod(registerFursMovablePremise),

  /** @see closeFursBusinessPremise */
  closeFursBusinessPremise: wrapMethod(closeFursBusinessPremise),
} as const;

export type FursPremisesApi = typeof fursPremises;
